module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#youtube",
      toString: function () {
        return this.url;
      }
    }